"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    PercentageBar: {
      display: 'flex',
      height: 82,
      '& div': {
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        fontWeight: 'bold',
        '& h3': {
          fontSize: 25,
          lineHeight: 1,
          margin: 0,
          color: theme['$text-color-light']
        },
        '& h4': {
          margin: 0,
          lineHeight: 1,
          wordBreak: 'keep-all',
          whiteSpace: 'nowrap',
          fontWeight: 'normal',
          fontSize: 12,
          color: theme['$text-color-light']
        }
      },
      '& > :nth-child(n)': {
        background: theme['$toggle-percent-bar-primary']
      },
      '& > :nth-child(2n)': {
        background: theme['$toggle-percent-bar-secondary']
      },
      '& > :nth-child(3n)': {
        background: theme['$toggle-percent-bar-tertiary']
      },
      '& > :nth-child(4n)': {
        background: theme['$toggle-percent-bar-quaternary']
      },
      '& .small-label': {
        fontSize: 10
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map